import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        baseUrl : 'https://www.enfancedesarts.com',
        baseJson : 'https://www.enfancedesarts.com/wp-json',
        user: null,
        token: localStorage.getItem('user-token') || '',
        currentEvent: null,
        fixedEvent : false,
        editingEventID : null,
    },
    mutations: {
        setUser (state , obj) {
            state.user = obj
        },
        setToken (state , obj) {
            state.token = obj
            localStorage.setItem('user-token', obj) // store the token in localstorage
        },
        setCurrentEvent (state , obj) {
            state.currentEvent = obj
        },
        setEditingEventID (state , obj) {
            state.editingEventID = obj
        },
        setFixedEvent (state , obj) {
            state.fixedEvent = obj
        },
    },
    actions : {
        async AutoLogin() {
            if (this.state.token) {
                return new Promise((resolve) => {
                    const url = this.state.baseUrl+'/?rest_route=/simple-jwt-login/v1/auth/validate&JWT='+this.state.token
                    axios.get(url).then( (res) => {
                        const user = res.data.data.user
                        this.state.user = user
                        resolve()
                    } ).catch( (error) => {
                        console.log(error)
                        return false
                    })
                })
            }
            return false
        },
        logout() {
            return new Promise((resolve) => {
                localStorage.removeItem('user-token')
                this.state.user = null
                this.state.token = localStorage.getItem('user-token') || ''
                resolve()
            })
        }
    }
})

export default store
